module.exports = __webpack_public_path__ + "static/media/stymex-1.502d31c7.jpg";